module.exports = __webpack_public_path__ + "img/upload.507411fe.svg";